export default "__VITE_ASSET__C$VIR5C___"